import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    fontFamily: 'Helvetica',
  },
  headerButtons: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '4px',
  },
  verticalToogleLine: {
    border: '1px solid #59A5F2',
    width: '22.58px',
    height: '0px',
    transform: 'rotate(90deg)',
  },
  thumbOn: {
    color: theme.palette.primary.main,
  },
  thumbOff: {
    color: theme.palette.general.grey,
  },
  track: {
    backgroundColor: `${theme.palette.primary.active} !important`,
    color: `${theme.palette.primary.active}`,
    opacity: '1 !important',
  },
  modalContainer: {
    background: theme.palette.background.paper,
    borderRadius: 16,
    overflow: 'auto',
    maxHeight: '100%',
    maxWidth: '990px',
    width: '100%',
    justifyContent: 'center',
  },
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.primary.main,
    alignItems: 'center',
    width: '100%',
  },
  exitIcon: {
    color: 'white',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
  },
  headerTitle: {
    fontStyle: 'normal',
    fontWeight: '900',
    fontSize: '14px',
    lineHeight: '60px',
    gap: '15px',
    display: 'flex',
    alignItems: 'center',
    textTransform: 'uppercase',
    color: theme.palette.primary.active,
  },
  bodyTitle: {
    height: '26px',
    fontStyle: 'normal',
    fontWeight: '900',
    fontSize: '24px',
    lineHeight: '26px',
    textAlign: 'right',
    letterSpacing: '0.01em',
    color: theme.palette.primary.active,
  },
  bodySubTitle: {
    fontStyle: 'normal',
    fontWeight: '900',
    fontSize: '49px',
    lineHeight: '40px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    letterSpacing: '0.01em',
    color: theme.palette.general.grey100,
  },

  footerButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    width: '145px',
    height: '26px',
    background: theme.palette.primary.main,
    borderRadius: '4px',
    fontFamily: 'Helvetica',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '10px',
    lineHeight: '11px',
    textAlign: 'center',
    color: theme.palette.primary.active,
  },
  bodyBoxTitles: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '60px 100px 10px',
    gap: '4px',
    height: '140px',
  },
  bodyBoxParagraphs: {
    display: 'flex',
    justifyContent: 'center',
  },
  bodyParagraph: {
    width: '45rem',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '19px',
    textAlign: 'center',
    letterSpacing: '0.01em',
    color: theme.palette.primary.active,
  },
  bodyBoxSteps: {
    display: 'flex',
    flexDirection: 'row',
    padding: '30px 0px',
    position: 'relative',
    width: '855px',
    overflow: 'hidden',
    transition: 'all 0.3s ease-in-out',
  },
  bodyBoxSteps2: {
    display: 'flex',
    flexDirection: 'row',
    padding: '30px 0px',
    position: 'relative',
    justifyContent: 'center',
    width: '855px',
  },
  moreInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px',
  },
  titleMoreInfo: {
    width: '434.79px',
    height: '19px',
    fontStyle: 'normal',
    fontWeight: '900',
    fontSize: '13px',
    lineHeight: '19px',
    textAlign: 'center',
    letterSpacing: '0.01em',
    color: theme.palette.primary.active,
  },
  arrowButton: {
    width: '30px',
    height: '30px',
    background: theme.palette.primary.dark,
    position: 'relative',
    borderRadius: '100%',
    border: '0px',
    margin: '0px',
    cursor: 'pointer',
  },
  carousel: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  carouselBox: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'row',
    transition: 'all 0.3s ease-in-out',
  },
  boxGradient: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: '48%',
    background: `linear-gradient(180deg, ${theme.palette.primary.main} 50%, rgba(56, 127, 247, 0) 100%)`,
    zIndex: 4,
    transform: 'rotate(90deg)',
  },
  mirror: {
    transform: 'rotate(180deg)',
  },
  bodyStep: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px 20px',
    margin: '0px 5px',
    width: '132px',
    height: '139px',
    justifyContent: 'space-between',
  },
  stepTop: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px',
    gap: '10px',
    width: '82px',
    borderRadius: '10px',
  },
  stepBottom: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px',
    gap: '6px',
    width: '92px',
  },
  rectangle: {
    width: '10px',
    height: '7px',
  },
  lineVertical: {
    width: '0px',
    height: '135px',
    borderRight: `1px dashed ${theme.palette.secondary.blue01}`,
  },
  lineHorizontal: {
    width: '700px',
    height: '0px',
    borderTop: `1px dashed ${theme.palette.secondary.blue01}`,
  },
  circle: {
    position: 'relative',
    width: '30px',
    height: '30px',
    borderRadius: '100%',
    background: theme.palette.general.grey100,
  },
  moreInfoParagraphs: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '20px 0px 26px',
    gap: '3px',

    width: '434.79px',
    height: '109px',
  },
  stepTitle: {
    fontStyle: 'normal',
    fontWeight: '900',
    fontSize: '13px',
    lineHeight: '13px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    color: theme.palette.primary.active,
  },
  stepNumber: {
    position: 'absolute',
    fontStyle: 'normal',
    fontWeight: '900',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    color: theme.palette.primary.warning,
    justifyContent: 'center',
    zIndex: 3,
  },
  modalHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 20px 8px 30px',
    justifyContent: 'space-between',
    height: '53.9px',
    width: '100%',
    background: theme.palette.primary.darkBlue,
  },
  modalFooter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 20px 20px 30px',
    gap: '10px',
    height: '66px',
    width: '100%',
    background: theme.palette.primary.dark,
  },
  actionButton: {
    width: '41px',
    height: '11px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 8px',
    gap: '4px',
    width: '92px',
    height: '26px',
    background: theme.palette.primary.dark,
    borderRadius: '4px',
    fontFamily: 'Helvetica',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '10px',
    lineHeight: '11px',
    textAlign: 'center',
    color: theme.palette.primary.active,
  },
  tutorialButton: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 8px',
    gap: '4px',
    width: '92px',
    height: '26px',
    border: `1px solid ${theme.palette.secondary.blue01}`,
    borderRadius: '4px',
    fontFamily: 'Helvetica',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '10px',
    lineHeight: '11px',
    textAlign: 'center',
    color: theme.palette.primary.active,
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  link: {
    width: '434.79px',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '19px',
    textAlign: 'center',
    letterSpacing: '0.01em',
    cursor: 'pointer',
    color: theme.palette.primary.active,
  },
  notificationsIcon: {
    color: theme.palette.common.white,
  },
}));

export default useStyles;
